import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { useParams } from "react-router-dom";
import { GrRefresh } from "react-icons/gr";
import { LuPrinter, LuClipboardCheck, LuCheck, LuX } from "react-icons/lu";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

import Button from "../../components/Button";

const PurchaseOrderDetails = () => {
  const { poNumber } = useParams();
  const token = useMemo(() => localStorage.getItem("token"), []);
  const encodedPoNumber = encodeURIComponent(poNumber);
  const [isLoading, setIsLoading] = useState(true);
  const [modeAlignment, setModeAlignment] = useState(false);

  const [detailPo, setDetailPo] = useState(null);
  const [poChanged, setPoChanged] = useState(null);

  const intervalRef = useRef(null);
  const expirationRef = useRef(null);

  const titleCase = (str) => {
    return str?.replace(/\b\w\S*/g, function (s) {
      return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
    });
  };

  const fetchDetailPo = useCallback(async () => {
    try {
      setModeAlignment(false);
      setIsLoading(true);
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/purchasing-order/${encodedPoNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (resp.data?.status === "INVALID") {
        return;
      }
      setDetailPo(resp.data.data);
      setDetailPo((prev) => {
        const newItem = prev.items.map((item) => {
          const newDiscountPercent = (item.discount / item.subtotal) * 100;
          const discount = Math.round(newDiscountPercent * 100) / 100;

          // jika discount 0, set discount percent ke "0.00"
          if (item.discount === 0) {
            return {
              ...item,
              discount_percent: "0.00",
            };
          } else if (isNaN(discount) || !isFinite(discount)) {
            return {
              ...item,
              discount_percent: "0.00",
            };
          } else {
            return {
              ...item,
              discount_percent: discount.toString(),
            };
          }
        });
        return { ...prev, items: newItem };
      });
      setIsLoading(false);
    } catch (error) {
      toast.error("Failed to fetch data");
    }
  }, [encodedPoNumber, token]);

  const handleSubmitAlignment = () => {
    setModeAlignment(!modeAlignment);
    fetchDetailPo();
  };

  const handleAlignmentMode = () => {
    setModeAlignment(!modeAlignment);
    setPoChanged(detailPo);
  };

  const handleCancelAlignment = () => {
    setModeAlignment(!modeAlignment);
    setPoChanged(null);
  };

  const handleChangePurhcaseOrder = (e, idItem) => {
    const { name, value } = e.target;
    console.log(name, value);
    switch (name) {
      case "items.price":
        setPoChanged((prev) => {
          // update item price and subtotal by index i
          // remove non-numeric characters except for dot and comma
          let subAmount = 0;
          const newItems = prev.items.map((item) => {
            if (item.id === idItem) {
              const newPrice = parseFloat(value.replace(/[^0-9,]+$/g, ""));
              const newSubtotal = newPrice * item.qty;
              subAmount += isNaN(newSubtotal) ? 0 : newSubtotal;
              return {
                ...item,
                price: isNaN(newPrice) ? 0 : newPrice,
                subtotal: isNaN(newSubtotal) ? 0 : newSubtotal,
              };
            } else {
              subAmount += item.subtotal;
            }
          });
          return { ...prev, sub_amount: subAmount, items: newItems };
        });
        break;
      case "items.discount_amount":
        setPoChanged((prev) => {
          let totalDiscount = 0;
          const newItems = prev.items.map((item) => {
            if (item.id === idItem) {
              const newDiscount = parseFloat(value.replace(/[^0-9,]+$/g, ""));
              if (newDiscount > item.subtotal) {
                return {
                  ...item,
                  discount: 0,
                  discount_percent: "0.00",
                };
              }
              const newDiscountPercent = (newDiscount / item.subtotal) * 100;
              if (newDiscountPercent > 100) {
                toast.error("Discount percent cannot be more than 100%");
                return {
                  ...item,
                  discount: item.subtotal,
                  discount_percent: "100",
                };
              }
              totalDiscount += isNaN(newDiscount) ? 0 : newDiscount;
              const discountPercent = isNaN(newDiscountPercent)
                ? "0.00"
                : Math.round(newDiscountPercent * 100) / 100;

              console.log("type discount amount", isNaN(newDiscount));
              return {
                ...item,
                discount: isNaN(newDiscount) ? 0 : newDiscount,
                discount_percent: discountPercent.toString()
                  ? discountPercent.toString()
                  : "0.00",
              };
            } else {
              totalDiscount += item.discount;
            }
            return item;
          });
          return {
            ...prev,
            discount: totalDiscount,
            total_amount: detailPo.total_amount - totalDiscount,
            items: newItems,
          };
        });
        break;
      case "items.discount_percent":
        setPoChanged((prev) => {
          // update item discount and subtotal by index i
          let totalDiscount = 0;
          const newItems = prev.items.map((item) => {
            if (item.id === idItem) {
              const newDiscount = parseFloat(value);
              if (!isNaN(newDiscount) && newDiscount > 100) {
                toast.error("Discount percent cannot be more than 100%");
                return {
                  ...item,
                  discount_percent: "100",
                  discount: item.subtotal,
                };
              }

              const discountAmount = (item.subtotal * newDiscount) / 100;
              totalDiscount += isNaN(newDiscount) ? 0 : newDiscount;
              return {
                ...item,
                discount_percent: value ? value : "0.00",
                discount: isNaN(discountAmount) ? 0 : discountAmount,
              };
            } else {
              totalDiscount += item.discount;
            }
            return item;
          });
          return {
            ...prev,
            discount: totalDiscount,
            total_amount: detailPo.total_amount - totalDiscount,
            items: newItems,
          };
        });
        break;
      case "tax":
        setPoChanged((prev) => {
          const newTax = e.target.checked
            ? 0
            : Math.round(prev.sub_amount * 0.11);
          const newTotalAmount = prev.sub_amount + newTax - prev.discount;
          return {
            ...prev,
            tax: newTax,
            total_amount: newTotalAmount,
          };
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    fetchDetailPo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetailPo]);

  useEffect(() => {
    console.log("discount change", poChanged?.items);
  }, [poChanged]);

  useEffect(() => {
    expirationRef.current = new Date().getTime() + 60 * 1000;

    intervalRef.current = setInterval(() => {
      const now = new Date().getTime();

      if (now > expirationRef.current) {
        clearInterval(intervalRef.current);
        console.log("Timer expired!");
        return;
      }

      console.log(`Current time: ${new Date().toLocaleString()}`);
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <main className="flex flex-col px-5 py-3 bg-white rounded-lg gap-4 overflow-visible">
      {/* Breadcrumb */}
      <nav className=" text-gray-700" aria-label="Breadcrumb">
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0 font-inter text-16 font-medium">
          <li>
            <div className="flex items-center text-sm font-normal text-gray-400">
              <a href="#" className="ml-0 hover:text-gray-500">
                Inventory
              </a>
            </div>
          </li>

          <li>
            <div className="flex items-center text-sm font-normal text-gray-400">
              <span>/</span>
              <a href="#" className="ms-1 md:ms-2 hover:text-gray-500">
                Purchase Order
              </a>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center text-sm font-normal text-gray-400">
              <span>/</span>
              <a href="#" className="ms-1 md:ms-2 hover:text-gray-500">
                Detail of <b>{poNumber}</b>
              </a>
            </div>
          </li>
          <button onClick={fetchDetailPo}>
            <GrRefresh
              className={`text-gray-400 hover:text-gray-500 ${isLoading ? "animate-spin" : ""}`}
            />
          </button>
        </ol>
      </nav>

      {/* Button */}
      <div className="flex gap-2">
        {detailPo?.status === "pending" ? (
          <>
            <Button isLoading={isLoading} variant="mint">
              <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
                Approve
              </span>
            </Button>
            <Button isLoading={isLoading} variant="mint">
              <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
                Cancel
              </span>
            </Button>
          </>
        ) : (
          detailPo?.status === "approved" && (
            <Button isLoading={isLoading} variant="mint">
              <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
                Receive
              </span>
            </Button>
          )
        )}

        <Button isLoading={isLoading} variant="mint">
          <LuPrinter className="text-white" />
          <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
            Cetak
          </span>
        </Button>
        <Button disabled={modeAlignment} isLoading={isLoading} variant="mint">
          <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
            Create New Invoice
          </span>
        </Button>
        <Button
          disabled={modeAlignment}
          isLoading={isLoading}
          variant="mint"
          onClick={handleAlignmentMode}
        >
          <LuClipboardCheck className="text-white" />
          <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
            Alignment
          </span>
        </Button>
        {modeAlignment && (
          <>
            <Button
              isLoading={isLoading}
              variant="mint"
              onClick={handleSubmitAlignment}
            >
              <LuCheck className="text-white" />
              <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
                OK
              </span>
            </Button>
            <Button
              isLoading={isLoading}
              variant="mint"
              onClick={handleCancelAlignment}
            >
              <LuX className="text-white" />
              <span className={`${isLoading ? "opacity-50" : "opacity-100"}`}>
                Cancel
              </span>
            </Button>
          </>
        )}
      </div>

      {/* Detail */}
      <div className="relative rounded-lg">
        {isLoading && (
          <div className="absolute inset-0 bg-white/60 backdrop-blur-sm flex items-center justify-center z-10">
            <svg
              className="animate-spin h-8 w-8 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          </div>
        )}
        <div className="flex flex-col gap-2">
          <h1 className="text-4xl font-bold text-gray-700 flex items-center gap-3">
            {poNumber}
            <span className="text-yellow-700 bg-yellow-100 px-3 py-1 rounded-full text-sm font-semibold">
              {titleCase(detailPo?.status)}
            </span>
          </h1>

          <span className="text-sm flex font-bold text-gray-700">
            Dibuat&nbsp;
            <p className="text-red-600 font-semibold">
              {detailPo?.created_at.replace("T", " ").split(".")[0]}
            </p>
          </span>

          <div className="grid grid-cols-4 md:grid-cols-4 gap-4 text-gray-700">
            <div>
              <h3 className="font-bold flex items-center gap-2 text-lg">
                Dari
              </h3>
              <p className="ml-5 font-semibold">
                {detailPo?.distributor.name} - {detailPo?.distributor.kota}
              </p>
              <p className="ml-5">{detailPo?.distributor.address}</p>
              <p className="ml-5">
                {detailPo?.distributor.phone},{detailPo?.distributor.email}
              </p>
            </div>

            <div>
              <h3 className="font-bold flex items-center gap-2 text-lg">
                Tujuan
              </h3>
              <p className="ml-5 font-semibold">
                {detailPo?.outlet.name} - {detailPo?.outlet.kota}
              </p>
              <p className="ml-5">{detailPo?.outlet.address}</p>
              <p className="ml-5">
                {detailPo?.outlet.phone},{detailPo?.outlet.email}
              </p>
            </div>

            <div>
              <h3 className="font-bold flex items-center gap-2 text-lg">
                Invoices
              </h3>
              <ul className="list-disc list-inside">
                {detailPo?.invoices.length === 0 ? (
                  <li className="font-poppins italic text-gray-400">
                    No Invoices
                  </li>
                ) : (
                  detailPo?.invoices.map((invoice) => (
                    <li className="font-poppins relative group hover:underline">
                      {invoice.number}
                      <div class="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-nowrap">
                        Rp {invoice.amount.toLocaleString("id-ID")} -{" "}
                        {invoice.paid_date === "0001-01-01T00:00:00Z"
                          ? "N/A"
                          : invoice.paid_date?.replace("T", "")[0]}
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>

            <div>
              <h3 className="font-bold flex items-center text-lg">Info</h3>
              <div className="ml-5 grid grid-cols-2 gap-2">
                <h4 className="font-semibold">Created By</h4>
                <p className="text-blue-500">
                  {detailPo?.created_by.id === 0
                    ? "Owner"
                    : detailPo?.created_by.fullname}
                </p>

                <h4 className="font-semibold">Method</h4>
                <span className="text-green-700 bg-green-100 text-center px-1 py-1 rounded-full text-sm font-semibold">
                  {titleCase(detailPo?.method)}
                </span>

                <h4 className="font-semibold">Approved By</h4>
                <p className="text-blue-500">
                  {detailPo?.approved_by.id === 0
                    ? "Owner"
                    : detailPo?.approved_by?.fullname}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className=" bg-white rounded-lg shadow overflow-clip">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className=" bg-green-100 text-gray-900">
            <tr>
              <th className="w-10 text-center" rowspan="2">
                N&nbsp;o
              </th>
              <th className="w-64 text-left" rowspan="2">
                N&nbsp;a&nbsp;m&nbsp;e
              </th>
              <th className="w-32 text-left" rowspan="2">
                P&nbsp;r&nbsp;i&nbsp;c&nbsp;e
              </th>
              <th className="w-20" rowspan="2">
                Qty
              </th>
              <th
                className="w-16 py-2 text-center border-b border-gray-600"
                colspan="2"
              >
                Discount
              </th>
              <th className="w-52" rowspan="2">
                Subtotal
              </th>
            </tr>
            <tr>
              <th className="py-2 w-1/12">%</th>
              <th className="py-2 w-1/5">Amount</th>
            </tr>
          </thead>
          <tbody className="relative">
            {isLoading && (
              <tr>
                <td colSpan={7} className="py-3 text-center">
                  <div className="absolute inset-0 bg-white/70 backdrop-blur-sm flex items-center justify-center z-10">
                    <svg
                      className="animate-spin h-8 w-8 text-green-600"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                  </div>
                  -
                </td>
              </tr>
            )}
            {!isLoading &&
              detailPo?.items.map((item, i) => (
                <tr id={item.id}>
                  <td className="py-2 text-center">{i + 1}</td>
                  <td>{item.obat.name}</td>
                  {/* Price */}
                  <td>
                    {modeAlignment ? (
                      <div className="flex py-1 items-center rounded-lg border border-gray-200 bg-white/5 pl-2">
                        <div class="shrink-0 text-base text-gray-400 select-none sm:text-sm/6">
                          Rp
                        </div>
                        <input
                          id="price"
                          type="text"
                          name="items.price"
                          className="w-full block min-w-0 grow pr-3 pl-1 text-base placeholder:text-gray-500 focus:outline-none sm:text-sm/6"
                          value={
                            poChanged?.items[i]?.price.toLocaleString(
                              "id-ID",
                            ) || item.price.toLocaleString("id-ID")
                          }
                          onChange={(e) =>
                            handleChangePurhcaseOrder(e, item.id)
                          }
                          min={0}
                        ></input>
                      </div>
                    ) : (
                      "Rp " + item.price.toLocaleString("id-ID")
                    )}
                  </td>
                  <td className="text-center">{item.qty}</td>

                  {/*discount percent */}
                  <td className="text-center">
                    {modeAlignment ? (
                      <input
                        type="text"
                        id="items.discount_percent"
                        name="items.discount_percent"
                        className="w-full px-2 rounded-lg border border-gray-200 py-1 text-center"
                        onFocus={() => {
                          const cur =
                            poChanged?.items[i]?.discount_percent ??
                            Number(item.discount_percent).toFixed(2);
                          if (/^0+(\.0+)?$/.test(String(cur))) {
                            handleChangePurhcaseOrder(
                              {
                                target: {
                                  name: "items.discount_percent",
                                  value: "",
                                },
                              },
                              item.id,
                            );
                          }
                        }}
                        onChange={(e) => {
                          let val = e.nativeEvent.target.value;

                          // hanya izinkan angka + titik
                          if (!/^\d*\.?\d*$/.test(val)) return;

                          if (val.includes(".")) {
                            const [intPart, decPart] = val.split(".");
                            if (decPart.length > 2) {
                              val = `${intPart}.${decPart.slice(0, 2)}`;
                            }
                          }

                          if (
                            (val === "0.00" || val === "0") &&
                            e.nativeEvent.data &&
                            e.nativeEvent.data !== "0"
                          ) {
                            val = e.nativeEvent.data;
                          }

                          if (/^0+\d/.test(val)) {
                            val = val.replace(/^0+(?=\d)/, "");
                          }

                          handleChangePurhcaseOrder(
                            {
                              target: {
                                name: "items.discount_percent",
                                value: val,
                              },
                            },
                            item.id,
                          );
                        }}
                        value={
                          poChanged?.items[i]?.discount_percent ||
                          item.discount_percent
                        }
                        onBlur={(e) => {
                          let num = parseFloat(e.target.value);
                          if (isNaN(num)) num = 0;
                          handleChangePurhcaseOrder(
                            {
                              target: {
                                name: "items.discount_percent",
                                value: num.toFixed(2),
                              },
                            },
                            item.id,
                          );
                        }}
                      />
                    ) : (
                      item.discount_percent + "%"
                    )}
                  </td>

                  {/* discount amount */}
                  <td className="ml-5">
                    {modeAlignment ? (
                      <input
                        type="text"
                        id="items.discount_amount"
                        name="items.discount_amount"
                        className="w-full px-2 rounded-lg border border-gray-200 py-1"
                        onFocus={() => {
                          const cur =
                            poChanged?.items[i]?.discount_amount ??
                            Number(item.discount_amount).toFixed(2);
                          if (/^0+(\.0+)?$/.test(String(cur))) {
                            handleChangePurhcaseOrder(
                              {
                                target: {
                                  name: "items.discount_amount",
                                  value: "",
                                },
                              },
                              item.id,
                            );
                          }
                        }}
                        onChange={(e) => {
                          let val = e.target.value;

                          // hanya izinkan angka + titik
                          if (!/^\d*\.?\d*$/.test(val)) return;

                          if (val.includes(".")) {
                            const [intPart, decPart] = val.split(".");
                            if (decPart.length > 2) {
                              val = `${intPart}.${decPart.slice(0, 2)}`;
                            }
                          }

                          if (/^0\d+/.test(val)) {
                            val = val.replace(/^0+/, "");
                          }

                          handleChangePurhcaseOrder(
                            {
                              target: {
                                name: "items.discount_amount",
                                value: val,
                              },
                            },
                            item.id,
                          );
                        }}
                        onBlur={(e) => {
                          let num = parseFloat(e.target.value);
                          if (isNaN(num)) num = 0;
                          handleChangePurhcaseOrder(
                            {
                              target: {
                                name: "items.discount_amount",
                                value: num.toFixed(2),
                              },
                            },
                            item.id,
                          );
                        }}
                        value={poChanged?.items[i]?.discount}
                      ></input>
                    ) : (
                      "Rp " + item.discount.toLocaleString("id-ID")
                    )}
                  </td>

                  <td className="ml-5 px-3">
                    Rp{" "}
                    {poChanged?.items[i]?.subtotal.toLocaleString("id-ID") ||
                      item.subtotal.toLocaleString("id-ID")}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <div className="ml-5 flex items-center gap-2">
        {modeAlignment ? (
          <input
            type="checkbox"
            id="tax"
            name="tax"
            checked={poChanged?.tax === 0}
            onChange={(e) => handleChangePurhcaseOrder(e, null)}
          />
        ) : (
          <input type="checkbox" name="tax" checked={detailPo?.tax === 0} />
        )}
        <label htmlFor="with-ppn" className="select-none">
          With PPN 11% (jika checked, maka harga item sudah termasuk PPN)
        </label>
      </div>

      {/* Footer */}
      <div className="relative rounded-lg">
        {isLoading && (
          <div className="absolute inset-0 bg-white/60 backdrop-blur-sm flex items-center justify-center z-10">
            <svg
              className="animate-spin h-8 w-8 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
          </div>
        )}
        <div className="flex flex-col justify-between">
          <div className="grid grid-cols-2 ">
            <div className="ml-5 max-w-md border-t border-gray-400 pt-4">
              <p>
                {detailPo?.description === "" ? "-" : detailPo?.description}
              </p>
            </div>

            <div className="mr-5 grid grid-cols-2 gap-1 border-t border-gray-400 pt-4 max-w-md justify-self-end">
              <h4 className="text-right">Untaxed Amount&nbsp;:</h4>
              <p className="font-semibold text-right">
                Rp{" "}
                {poChanged?.sub_amount.toLocaleString("id-ID") ||
                  detailPo?.sub_amount.toLocaleString("id-ID")}
              </p>

              <h4 className="text-right">Tax (PPN 11%)&nbsp;:</h4>
              <p className="font-semibold text-right">
                Rp{" "}
                {poChanged?.tax.toLocaleString("id-ID") ||
                  detailPo?.tax.toLocaleString("id-ID")}
              </p>

              <h4 className="text-right">Discount&nbsp;:</h4>
              <p className="font-semibold text-right">
                Rp{" "}
                {poChanged?.discount.toLocaleString("id-ID") ||
                  detailPo?.discount.toLocaleString("id-ID")}
              </p>

              <h4 className="pt-3 font-semibold text-right text-xl">
                Total Amount&nbsp;:
              </h4>
              <p className="pt-3 font-extrabold text-right text-xl">
                Rp{" "}
                {poChanged?.total_amount.toLocaleString("id-ID") ||
                  detailPo?.total_amount.toLocaleString("id-ID")}
              </p>
            </div>
          </div>
        </div>
      </div>

      <Toaster position="top-right" reverseOrder={true} />
    </main>
  );
};
export default PurchaseOrderDetails;
